<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Billing</h1>
    <div class="bg-white shadow-1">
      <q-tabs
        v-model="tab"
        active-color="primary"
        indicator-color="primary"
        align="justify"
      >
        <q-tab name="payment_methods" label="Payment Methods" />
        <q-tab name="receipts" label="Receipts" />
      </q-tabs>
      <q-separator />
      <q-tab-panels v-model="tab" animated>
        <q-tab-panel name="payment_methods">
          <payment-methods :customer-id="accountId" class="q-pa-sm" />
        </q-tab-panel>
        <q-tab-panel name="receipts">
          <charges-table :customer-id="accountId" flat />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </q-page>
</template>

<style>
</style>

<script>
import { AccountContextMixin } from '@/mixins';
import PaymentMethods from '../payment-method/PaymentMethods.vue';
import ChargesTable from '../billing/charge/ChargesTable.vue';

export default {
  meta: {
    title: 'Billing',
  },
  mixins: [AccountContextMixin],
  components: {
    PaymentMethods,
    ChargesTable,
  },
  data() {
    return {
      tab: 'payment_methods',
    };
  },
};
</script>
